import type { ReactNode } from 'react';
import { cn } from '../../../utils/cn';
import styles from './Badge.module.css';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'muted';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
}

export function Badge({ variant = 'default', children, className, icon }: BadgeProps) {
  return (
    <span className={cn(styles.badge, styles[variant], className)}>
      {icon}
      {children}
    </span>
  );
}
